import React from 'react';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import Sidebar from '../Sidebar/MenuLeft';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';



class Page extends React.Component {


    render() {
        return (
            <div>
                <MenuNew />
                <NavbarDrop />

                <Container id="wallet_slip">
                    <div className="wallet_slip_img_inst">
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>GOVERNANÇA</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>

                </Container>

                <Container style={{ marginTop: -40 }}>
                    <Row style={{ marginRight: 0 }}>
                        <Col style={{ marginTop: 60, marginRight: 35 }} xs="12" sm="12" md="2" lg="2" xl="2">
                            <Sidebar />
                        </Col>
                        <Col style={{ marginTop: 60, margiLeft: 20 }} xs="12" sm="12" md="10" lg="10" xl="8">
                            <p style={{ textAlign: 'justify' }}>
                                A Dental Center, em 2019, iniciou a estruturação rumo a um novo modelo de gestão,  pautada na Governança Corporativa, sustentada pelos princípios da transparência, a equidade, prestação de contas e responsabilidade corporativa.
                                O Instituto Brasileiro de Governança Corporativa (IBGC, 2019) define que a Governança  é o sistema pelo qual as empresas e demais organizações são dirigidas, monitoradas e incentivadas, envolvendo os relacionamentos entre sócios, conselho de administração, diretoria, órgãos de fiscalização e controle e demais partes interessadas.
                                Esse sistema norteia toda a nossa estrutura em busca de garantir a sustentabilidade do nosso negócio.
                           </p>
                        </Col>
                    </Row>
                </Container>

                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Governanca/Page.js
 **/